export default __webpack_public_path__ + "static/media/no-found.a1f82a96.png";